export default __webpack_public_path__ + "static/media/mic.0382a71a.png";